import { MessageSquare } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatures from '../../components/services/sections/ServiceFeatures';
import ServiceBenefits from '../../components/services/sections/ServiceBenefits';
import ServiceSteps from '../../components/services/sections/ServiceSteps';
import { offreIAFeatures } from '../../data/services/offreIA';
import { colors } from '../../styles/theme';

const benefits = [
    {
        value: 'Beta',
        label: 'Accès exclusif en avant-première'
    },
    {
        value: '100%',
        label: 'Gratuit pour les étudiants'
    },
    {
        value: 'Illimité',
        label: 'Accès sans limite aux modèles ChatGPT et Claude'
    }
];

const steps = [
    {
        title: 'Inscrivez-vous sur FRANCE STUDENT',
        description: 'Créez votre compte étudiant en quelques clics.'
    },
    {
        title: 'Vérifiez votre statut étudiant',
        description: 'Téléchargez votre carte étudiante ou certificat de scolarité.'
    },
    {
        title: 'Préinscrivez-vous à l’Offre IA',
        description: 'Remplissez le formulaire pour faire partie des premiers utilisateurs.'
    }
];

const OffreIAPage = () => {
    const handleClick = () => {
        window.location.href = 'https://my.francestudent.org/store/offreia';
    };

    return (
        <div>
            <ServiceHeader
                title="Offre IA (Beta)"
                description="Participez à la phase Beta de notre Offre IA et profitez d’un accès anticipé aux modèles ChatGPT et Claude sans limite."
                icon={<MessageSquare className="w-8 h-8 text-white" />}
                color={colors.primary}
                imageUrl="https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/ChatGPT_logo.svg/1200px-ChatGPT_logo.svg.png"
            />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <ServiceFeatures
                    title="Modèles IA inclus"
                    features={offreIAFeatures}
                    color={colors.primary}
                />

                <ServiceBenefits
                    title="Pourquoi commander l'offre ?"
                    benefits={benefits}
                    color={colors.primary}
                />

                <ServiceSteps
                    title="Comment en bénéficier"
                    steps={steps}
                    color={colors.primary}
                    ctaText="Activer l'Offre IA"
                    onCtaClick={handleClick}
                />
            </div>
        </div>
    );
};

export default OffreIAPage;